// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicSpotGetCurrencies (params?: {}): Promise<Dict>;
    publicSpotGetDepth (params?: {}): Promise<Dict>;
    publicSpotGetKline (params?: {}): Promise<Dict>;
    publicSpotGetSymbol (params?: {}): Promise<Dict>;
    publicSpotGetTicker (params?: {}): Promise<Dict>;
    publicSpotGetTickerBook (params?: {}): Promise<Dict>;
    publicSpotGetTickerPrice (params?: {}): Promise<Dict>;
    publicSpotGetTicker24h (params?: {}): Promise<Dict>;
    publicSpotGetTime (params?: {}): Promise<Dict>;
    publicSpotGetTradeHistory (params?: {}): Promise<Dict>;
    publicSpotGetTradeRecent (params?: {}): Promise<Dict>;
    publicSpotGetWalletSupportCurrency (params?: {}): Promise<Dict>;
    publicLinearGetFutureMarketV1PublicContractRiskBalance (params?: {}): Promise<Dict>;
    publicLinearGetFutureMarketV1PublicContractOpenInterest (params?: {}): Promise<Dict>;
    publicLinearGetFutureMarketV1PublicLeverageBracketDetail (params?: {}): Promise<Dict>;
    publicLinearGetFutureMarketV1PublicLeverageBracketList (params?: {}): Promise<Dict>;
    publicLinearGetFutureMarketV1PublicQAggTicker (params?: {}): Promise<Dict>;
    publicLinearGetFutureMarketV1PublicQAggTickers (params?: {}): Promise<Dict>;
    publicLinearGetFutureMarketV1PublicQDeal (params?: {}): Promise<Dict>;
    publicLinearGetFutureMarketV1PublicQDepth (params?: {}): Promise<Dict>;
    publicLinearGetFutureMarketV1PublicQFundingRate (params?: {}): Promise<Dict>;
    publicLinearGetFutureMarketV1PublicQFundingRateRecord (params?: {}): Promise<Dict>;
    publicLinearGetFutureMarketV1PublicQIndexPrice (params?: {}): Promise<Dict>;
    publicLinearGetFutureMarketV1PublicQKline (params?: {}): Promise<Dict>;
    publicLinearGetFutureMarketV1PublicQMarkPrice (params?: {}): Promise<Dict>;
    publicLinearGetFutureMarketV1PublicQSymbolIndexPrice (params?: {}): Promise<Dict>;
    publicLinearGetFutureMarketV1PublicQSymbolMarkPrice (params?: {}): Promise<Dict>;
    publicLinearGetFutureMarketV1PublicQTicker (params?: {}): Promise<Dict>;
    publicLinearGetFutureMarketV1PublicQTickerBooks (params?: {}): Promise<Dict>;
    publicLinearGetFutureMarketV1PublicQTickers (params?: {}): Promise<Dict>;
    publicLinearGetFutureMarketV1PublicSymbolCoins (params?: {}): Promise<Dict>;
    publicLinearGetFutureMarketV1PublicSymbolDetail (params?: {}): Promise<Dict>;
    publicLinearGetFutureMarketV1PublicSymbolList (params?: {}): Promise<Dict>;
    publicInverseGetFutureMarketV1PublicContractRiskBalance (params?: {}): Promise<Dict>;
    publicInverseGetFutureMarketV1PublicContractOpenInterest (params?: {}): Promise<Dict>;
    publicInverseGetFutureMarketV1PublicLeverageBracketDetail (params?: {}): Promise<Dict>;
    publicInverseGetFutureMarketV1PublicLeverageBracketList (params?: {}): Promise<Dict>;
    publicInverseGetFutureMarketV1PublicQAggTicker (params?: {}): Promise<Dict>;
    publicInverseGetFutureMarketV1PublicQAggTickers (params?: {}): Promise<Dict>;
    publicInverseGetFutureMarketV1PublicQDeal (params?: {}): Promise<Dict>;
    publicInverseGetFutureMarketV1PublicQDepth (params?: {}): Promise<Dict>;
    publicInverseGetFutureMarketV1PublicQFundingRate (params?: {}): Promise<Dict>;
    publicInverseGetFutureMarketV1PublicQFundingRateRecord (params?: {}): Promise<Dict>;
    publicInverseGetFutureMarketV1PublicQIndexPrice (params?: {}): Promise<Dict>;
    publicInverseGetFutureMarketV1PublicQKline (params?: {}): Promise<Dict>;
    publicInverseGetFutureMarketV1PublicQMarkPrice (params?: {}): Promise<Dict>;
    publicInverseGetFutureMarketV1PublicQSymbolIndexPrice (params?: {}): Promise<Dict>;
    publicInverseGetFutureMarketV1PublicQSymbolMarkPrice (params?: {}): Promise<Dict>;
    publicInverseGetFutureMarketV1PublicQTicker (params?: {}): Promise<Dict>;
    publicInverseGetFutureMarketV1PublicQTickerBooks (params?: {}): Promise<Dict>;
    publicInverseGetFutureMarketV1PublicQTickers (params?: {}): Promise<Dict>;
    publicInverseGetFutureMarketV1PublicSymbolCoins (params?: {}): Promise<Dict>;
    publicInverseGetFutureMarketV1PublicSymbolDetail (params?: {}): Promise<Dict>;
    publicInverseGetFutureMarketV1PublicSymbolList (params?: {}): Promise<Dict>;
    privateSpotGetBalance (params?: {}): Promise<Dict>;
    privateSpotGetBalances (params?: {}): Promise<Dict>;
    privateSpotGetBatchOrder (params?: {}): Promise<Dict>;
    privateSpotGetDepositAddress (params?: {}): Promise<Dict>;
    privateSpotGetDepositHistory (params?: {}): Promise<Dict>;
    privateSpotGetHistoryOrder (params?: {}): Promise<Dict>;
    privateSpotGetOpenOrder (params?: {}): Promise<Dict>;
    privateSpotGetOrder (params?: {}): Promise<Dict>;
    privateSpotGetOrderOrderId (params?: {}): Promise<Dict>;
    privateSpotGetTrade (params?: {}): Promise<Dict>;
    privateSpotGetWithdrawHistory (params?: {}): Promise<Dict>;
    privateSpotPostOrder (params?: {}): Promise<Dict>;
    privateSpotPostWithdraw (params?: {}): Promise<Dict>;
    privateSpotPostBalanceTransfer (params?: {}): Promise<Dict>;
    privateSpotPostBalanceAccountTransfer (params?: {}): Promise<Dict>;
    privateSpotPostWsToken (params?: {}): Promise<Dict>;
    privateSpotDeleteBatchOrder (params?: {}): Promise<Dict>;
    privateSpotDeleteOpenOrder (params?: {}): Promise<Dict>;
    privateSpotDeleteOrderOrderId (params?: {}): Promise<Dict>;
    privateSpotPutOrderOrderId (params?: {}): Promise<Dict>;
    privateLinearGetFutureTradeV1EntrustPlanDetail (params?: {}): Promise<Dict>;
    privateLinearGetFutureTradeV1EntrustPlanList (params?: {}): Promise<Dict>;
    privateLinearGetFutureTradeV1EntrustPlanListHistory (params?: {}): Promise<Dict>;
    privateLinearGetFutureTradeV1EntrustProfitDetail (params?: {}): Promise<Dict>;
    privateLinearGetFutureTradeV1EntrustProfitList (params?: {}): Promise<Dict>;
    privateLinearGetFutureTradeV1EntrustTrackDetail (params?: {}): Promise<Dict>;
    privateLinearGetFutureTradeV1EntrustTrackList (params?: {}): Promise<Dict>;
    privateLinearGetFutureTradeV1EntrustTrackListHistory (params?: {}): Promise<Dict>;
    privateLinearGetFutureTradeV1OrderDetail (params?: {}): Promise<Dict>;
    privateLinearGetFutureTradeV1OrderList (params?: {}): Promise<Dict>;
    privateLinearGetFutureTradeV1OrderListHistory (params?: {}): Promise<Dict>;
    privateLinearGetFutureTradeV1PositionListHistory (params?: {}): Promise<Dict>;
    privateLinearGetFutureTradeV1OrderTradeList (params?: {}): Promise<Dict>;
    privateLinearGetFutureUserV1AccountInfo (params?: {}): Promise<Dict>;
    privateLinearGetFutureUserV1BalanceBills (params?: {}): Promise<Dict>;
    privateLinearGetFutureUserV1BalanceDetail (params?: {}): Promise<Dict>;
    privateLinearGetFutureUserV1BalanceFundingRateList (params?: {}): Promise<Dict>;
    privateLinearGetFutureUserV1BalanceList (params?: {}): Promise<Dict>;
    privateLinearGetFutureUserV1PositionAdl (params?: {}): Promise<Dict>;
    privateLinearGetFutureUserV1PositionBreakList (params?: {}): Promise<Dict>;
    privateLinearGetFutureUserV1PositionList (params?: {}): Promise<Dict>;
    privateLinearGetFutureUserV1UserStepRate (params?: {}): Promise<Dict>;
    privateLinearGetFutureUserV1UserCollectionList (params?: {}): Promise<Dict>;
    privateLinearGetFutureUserV1UserListenKey (params?: {}): Promise<Dict>;
    privateLinearPostFutureTradeV1EntrustCancelAllPlan (params?: {}): Promise<Dict>;
    privateLinearPostFutureTradeV1EntrustCancelAllProfitStop (params?: {}): Promise<Dict>;
    privateLinearPostFutureTradeV1EntrustCancelAllTrack (params?: {}): Promise<Dict>;
    privateLinearPostFutureTradeV1EntrustCancelPlan (params?: {}): Promise<Dict>;
    privateLinearPostFutureTradeV1EntrustCancelProfitStop (params?: {}): Promise<Dict>;
    privateLinearPostFutureTradeV1EntrustCreatePlan (params?: {}): Promise<Dict>;
    privateLinearPostFutureTradeV1EntrustCancelTrack (params?: {}): Promise<Dict>;
    privateLinearPostFutureTradeV1EntrustCreateProfit (params?: {}): Promise<Dict>;
    privateLinearPostFutureTradeV1EntrustCreateTrack (params?: {}): Promise<Dict>;
    privateLinearPostFutureTradeV1EntrustUpdateProfitStop (params?: {}): Promise<Dict>;
    privateLinearPostFutureTradeV1OrderCancel (params?: {}): Promise<Dict>;
    privateLinearPostFutureTradeV1OrderCancelAll (params?: {}): Promise<Dict>;
    privateLinearPostFutureTradeV1OrderCreate (params?: {}): Promise<Dict>;
    privateLinearPostFutureTradeV1OrderCreateBatch (params?: {}): Promise<Dict>;
    privateLinearPostFutureTradeV1OrderUpdate (params?: {}): Promise<Dict>;
    privateLinearPostFutureUserV1AccountOpen (params?: {}): Promise<Dict>;
    privateLinearPostFutureUserV1PositionAdjustLeverage (params?: {}): Promise<Dict>;
    privateLinearPostFutureUserV1PositionAutoMargin (params?: {}): Promise<Dict>;
    privateLinearPostFutureUserV1PositionCloseAll (params?: {}): Promise<Dict>;
    privateLinearPostFutureUserV1PositionMargin (params?: {}): Promise<Dict>;
    privateLinearPostFutureUserV1UserCollectionAdd (params?: {}): Promise<Dict>;
    privateLinearPostFutureUserV1UserCollectionCancel (params?: {}): Promise<Dict>;
    privateLinearPostFutureUserV1PositionChangeType (params?: {}): Promise<Dict>;
    privateInverseGetFutureTradeV1EntrustPlanDetail (params?: {}): Promise<Dict>;
    privateInverseGetFutureTradeV1EntrustPlanList (params?: {}): Promise<Dict>;
    privateInverseGetFutureTradeV1EntrustPlanListHistory (params?: {}): Promise<Dict>;
    privateInverseGetFutureTradeV1EntrustProfitDetail (params?: {}): Promise<Dict>;
    privateInverseGetFutureTradeV1EntrustProfitList (params?: {}): Promise<Dict>;
    privateInverseGetFutureTradeV1EntrustTrackDetail (params?: {}): Promise<Dict>;
    privateInverseGetFutureTradeV1EntrustTrackList (params?: {}): Promise<Dict>;
    privateInverseGetFutureTradeV1EntrustTrackListHistory (params?: {}): Promise<Dict>;
    privateInverseGetFutureTradeV1OrderDetail (params?: {}): Promise<Dict>;
    privateInverseGetFutureTradeV1OrderList (params?: {}): Promise<Dict>;
    privateInverseGetFutureTradeV1OrderListHistory (params?: {}): Promise<Dict>;
    privateInverseGetFutureTradeV1PositionListHistory (params?: {}): Promise<Dict>;
    privateInverseGetFutureTradeV1OrderTradeList (params?: {}): Promise<Dict>;
    privateInverseGetFutureUserV1AccountInfo (params?: {}): Promise<Dict>;
    privateInverseGetFutureUserV1BalanceBills (params?: {}): Promise<Dict>;
    privateInverseGetFutureUserV1BalanceDetail (params?: {}): Promise<Dict>;
    privateInverseGetFutureUserV1BalanceFundingRateList (params?: {}): Promise<Dict>;
    privateInverseGetFutureUserV1BalanceList (params?: {}): Promise<Dict>;
    privateInverseGetFutureUserV1PositionAdl (params?: {}): Promise<Dict>;
    privateInverseGetFutureUserV1PositionBreakList (params?: {}): Promise<Dict>;
    privateInverseGetFutureUserV1PositionList (params?: {}): Promise<Dict>;
    privateInverseGetFutureUserV1UserStepRate (params?: {}): Promise<Dict>;
    privateInverseGetFutureUserV1UserCollectionList (params?: {}): Promise<Dict>;
    privateInverseGetFutureUserV1UserListenKey (params?: {}): Promise<Dict>;
    privateInversePostFutureTradeV1EntrustCancelAllPlan (params?: {}): Promise<Dict>;
    privateInversePostFutureTradeV1EntrustCancelAllProfitStop (params?: {}): Promise<Dict>;
    privateInversePostFutureTradeV1EntrustCancelAllTrack (params?: {}): Promise<Dict>;
    privateInversePostFutureTradeV1EntrustCancelPlan (params?: {}): Promise<Dict>;
    privateInversePostFutureTradeV1EntrustCancelProfitStop (params?: {}): Promise<Dict>;
    privateInversePostFutureTradeV1EntrustCreatePlan (params?: {}): Promise<Dict>;
    privateInversePostFutureTradeV1EntrustCancelTrack (params?: {}): Promise<Dict>;
    privateInversePostFutureTradeV1EntrustCreateProfit (params?: {}): Promise<Dict>;
    privateInversePostFutureTradeV1EntrustCreateTrack (params?: {}): Promise<Dict>;
    privateInversePostFutureTradeV1EntrustUpdateProfitStop (params?: {}): Promise<Dict>;
    privateInversePostFutureTradeV1OrderCancel (params?: {}): Promise<Dict>;
    privateInversePostFutureTradeV1OrderCancelAll (params?: {}): Promise<Dict>;
    privateInversePostFutureTradeV1OrderCreate (params?: {}): Promise<Dict>;
    privateInversePostFutureTradeV1OrderCreateBatch (params?: {}): Promise<Dict>;
    privateInversePostFutureTradeV1OrderUpdate (params?: {}): Promise<Dict>;
    privateInversePostFutureUserV1AccountOpen (params?: {}): Promise<Dict>;
    privateInversePostFutureUserV1PositionAdjustLeverage (params?: {}): Promise<Dict>;
    privateInversePostFutureUserV1PositionAutoMargin (params?: {}): Promise<Dict>;
    privateInversePostFutureUserV1PositionCloseAll (params?: {}): Promise<Dict>;
    privateInversePostFutureUserV1PositionMargin (params?: {}): Promise<Dict>;
    privateInversePostFutureUserV1UserCollectionAdd (params?: {}): Promise<Dict>;
    privateInversePostFutureUserV1UserCollectionCancel (params?: {}): Promise<Dict>;
    privateInversePostFutureUserV1PositionChangeType (params?: {}): Promise<Dict>;
    privateUserGetUserAccount (params?: {}): Promise<Dict>;
    privateUserGetUserAccountApiKey (params?: {}): Promise<Dict>;
    privateUserPostUserAccount (params?: {}): Promise<Dict>;
    privateUserPostUserAccountApiKey (params?: {}): Promise<Dict>;
    privateUserPutUserAccountApiKey (params?: {}): Promise<Dict>;
    privateUserDeleteUserAccountApiKeyId (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
